import React from 'react'
import { IItemModel } from './ItemsApp'
import { useDispatch } from 'react-redux'
import { updateContainerId, updateOpenContainedItemsStatus } from './itemsSlice'

interface IProps {
    item: IItemModel
}

export default function ShowContainedItemsButton(props: IProps) {

    const dispatch = useDispatch()

    const { item } = props

    /**
     * update
     */
    const update = () => {
        dispatch(updateContainerId(item.id))
        dispatch(updateOpenContainedItemsStatus(true))
    }

    return <p className="show-all-locations" onClick={() => update()}>Show contained items</p>
}